import React, {FC} from 'react';
import {BackgroundContainer, LoadingSpinner} from 'components';
import {withDigitalPracticeProvider} from 'components/HOCs';
import {useCookie} from 'hooks/useCookie';
import {
  DigitalPracticeProvider,
  SliceStatus,
  StripePlanDurations,
  StripePlanNames,
} from 'interfaces';
import {Helmet} from 'react-helmet-async';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {isMobile} from 'utils';

import {OutsideWellniteRegisterForm} from './OutsideWellniteRegisterForm';
import ReferralsDetails from './referralsDetails';

const RegisterPractice: FC<{
  provider: DigitalPracticeProvider;
  providerLoadingStatus: SliceStatus;
}> = ({provider, providerLoadingStatus}) => {
  useCookie();
  const {t} = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('title.register')}</title>
      </Helmet>
      <BackgroundContainer
        containerClasses="w-full h-full px-5 md:px-[100px] pt-14 pb-10 lg:bg-white overflow-y-auto font-inter"
        id="doctor-consultation-onboarding-form"
        isMobile={isMobile}
        showClose={false}
      >
        {/* Referrals Details */}
        {providerLoadingStatus === SliceStatus.pending ? (
          <div className="flex justify-center py-6">
            <LoadingSpinner width={24} height={24} />
          </div>
        ) : (
          <ReferralsDetails
            avatar={
              provider?.image ||
              'https://firebasestorage.googleapis.com/v0/b/wellnite-chat-production.appspot.com/o/Image%2Fplaceholer-image.png?alt=media&token=e6e44bf5-e204-4d0c-912b-6afd47b4f167'
            }
            name={provider?.fullName}
            email={provider?.email}
          />
        )}

        <article className="mx-auto text-center pt-3">
          <p className="md:text-3xl font-bold font-montserrat">
            {t('welcome')}
          </p>
          <p className="text-center text-gray-700 pt-2 font-normal font-inter">
            {t('lets_get_started')}
          </p>
        </article>
        <section className="pt-6 lg:pt-4 pb-6">
          <OutsideWellniteRegisterForm
            referralCode=""
            referralSource=""
            paymentPlan={StripePlanNames.medicalCare}
            paymentPlanDuration={StripePlanDurations.biweekly}
            provider={provider}
            providerLoadingStatus={providerLoadingStatus}
            containerUtilities="md:max-w-sm lg:max-w-sm mx-auto pt-4 md:pt-1 lg:pt-8"
          />

          <p className="text-center leading-snug text-xs font-light">
            {t('already_have_an_account')}{' '}
            <Link to="/login">
              <span className="text-blue-600">{t('login')}</span>
            </Link>
          </p>
        </section>
      </BackgroundContainer>
    </>
  );
};

export default withDigitalPracticeProvider(RegisterPractice);
